import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-458b027f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-search-bar p-grid p-col-12" }
const _hoisted_2 = { class: "search-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Search", -1))
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-filters" }, null, -1))
const _hoisted_7 = { class: "search-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.searchTerm,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
          placeholder: _ctx.placeholder,
          onKeyup: _withKeys(_ctx.startSearch, ["enter"])
        }, null, 8, ["modelValue", "placeholder", "onKeyup"])
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Button, {
        label: "Clear filters",
        class: "clear",
        onClick: _ctx.clearSearch
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Search",
        onClick: _ctx.startSearch
      }, null, 8, ["onClick"])
    ])
  ]))
}